import { useEffect } from 'react';
import {
  useParams,
  useNavigate,
  generatePath,
  useMatch,
} from 'react-router-dom';
import { NostroSidepanel } from '@ui/src';
import { useAppDispatch, useAppSelector } from '@store';
import { clearTransactionState } from '../../store/slices/problem-transactions/nostro-transaction';
import useProblemNostroTransaction from './hooks/use-nostro';

const ProblemNostroTransactionHOC = ({
  backPath,
  generalPath,
  logPath,
  matchPath,
  changeLogPath,
  commentsPath,
}: {
  backPath: string;
  generalPath: string;
  logPath: string;
  matchPath: string;
  changeLogPath: string;
  commentsPath: string;
}): React.JSX.Element => {
  const { transaction } = useAppSelector(
    (state) => state.customersProblemTransactions.nostro,
  );
  const { currencies: currenciesList } = useAppSelector((state) => state.root);

  const { customerId, transactionId } = useParams();

  const {
    setPanelIsOpen,
    search,
    panelIsOpen,
    handleClose,
    logsIsLoading,
    isLoading,
    isFetching,
    getNostroTransactionById,
  } = useProblemNostroTransaction({
    transactionId,
    backPath,
    customerId,
    transaction,
  });

  const match = useMatch(matchPath);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    setPanelIsOpen(true);

    return () => {
      dispatch(clearTransactionState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (match && customerId && transactionId) {
      navigate(
        generatePath(`${generalPath}${search || ''}`, {
          customerId,
          transactionId,
        }),
      );
    }
  }, [match, customerId, transactionId]);

  useEffect(() => {
    if (customerId && !transaction && transactionId) {
      getNostroTransactionById();
    }
  }, [getNostroTransactionById, customerId, transaction, transactionId]);

  return (
    <NostroSidepanel
      panelIsOpen={panelIsOpen}
      handleClose={handleClose}
      transactionInfo={transaction}
      tabs={{
        generalPath: generatePath(`${generalPath}${search || ''}`, {
          customerId,
          transactionId,
        }),
        logPath: generatePath(`${logPath}${search || ''}`, {
          customerId,
          transactionId,
        }),
        changeLogPath: generatePath(`${changeLogPath}${search || ''}`, {
          customerId,
          transactionId,
        }),
        commentsPath: generatePath(`${commentsPath}${search || ''}`, {
          customerId,
          transactionId,
        }),
      }}
      isLoading={logsIsLoading || isLoading || isFetching}
      title="Nostro Transaction"
      currenciesList={currenciesList}
      sidepanelExpandedKey="problem-nostro"
    />
  );
};

export default ProblemNostroTransactionHOC;
